import RestClientService from 'Services/RestClientService';

class ReportApiService {
  static async generateStaffingListReport(data) {
    return RestClientService.Post('Report/staffing-list', data);
  }

  static async generateResignReport(data) {
    return RestClientService.Post('Report/resign', data);
  }

  static async createExcelReport() {
    return RestClientService.Post('excelNew', {});
  }
}

export default ReportApiService;
